import { visibleButton } from "../include/module";
import { anchorLink } from "../include/module";



const breakPointPC = 1279;
const breakPointSP = 767;
let resizeFlag     = false;
let windowWidth    = window.innerWidth;
let windowHeight   = window.innerHeight;
let windowWidthJ   = $(window).width();



(() => {
  visibleButton();
  anchorLink();
})();

$(document).ready(function() {
  $('.popup-movie').magnificPopup({
    type: 'iframe',
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com',
          id: 'v=',
          src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1&mute=1'
        }
      }
    },
    mainClass: 'mfp-fade',
    removalDelay: 150,
    preloader: false
  });
});



// WEBPACK FOOTER //
// ./src/assets/js/miku2/script.js